"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = require("./util.js");

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/AssertionError
 */


/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
 */
var AssertionError =
/** @class */
function (_super) {
  __extends(AssertionError, _super);
  /**
   * @param {number} code Error code.
   */


  function AssertionError(code) {
    var _this = this;

    var path = _util.VERSION === 'latest' ? _util.VERSION : 'v' + _util.VERSION.split('-')[0];
    var message = 'Assertion failed. See https://openlayers.org/en/' + path + '/doc/errors/#' + code + ' for details.';
    _this = _super.call(this, message) || this;
    /**
     * Error code. The meaning of the code can be found on
     * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
     * the version found in the OpenLayers script's header comment if a version
     * other than the latest is used).
     * @type {number}
     * @api
     */

    _this.code = code;
    /**
     * @type {string}
     */

    _this.name = 'AssertionError'; // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40

    _this.message = message;
    return _this;
  }

  return AssertionError;
}(Error);

var _default = AssertionError;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUhBOzs7OztBQUtBOzs7OztBQUtBO0FBQUE7QUFBQTtFQUE2QkE7RUFDM0I7Ozs7O0VBR0Esd0JBQVlDLElBQVosRUFBZ0I7SUFBaEI7O0lBQ0UsSUFBTUMsSUFBSSxHQUFHQyxrQkFBWSxRQUFaLEdBQXVCQSxhQUF2QixHQUFpQyxNQUFNQSxjQUFRQyxLQUFSLENBQWMsR0FBZCxFQUFtQixDQUFuQixDQUFwRDtJQUNBLElBQU1DLE9BQU8sR0FDWCxxREFDQUgsSUFEQSxHQUVBLGVBRkEsR0FHQUQsSUFIQSxHQUlBLGVBTEY7WUFPQUssa0JBQU1ELE9BQU4sS0FBYztJQUVkOzs7Ozs7Ozs7SUFRQUUsS0FBSSxDQUFDTixJQUFMLEdBQVlBLElBQVo7SUFFQTs7OztJQUdBTSxLQUFJLENBQUNDLElBQUwsR0FBWSxnQkFBWixDQXhCYyxDQTBCZDs7SUFDQUQsS0FBSSxDQUFDRixPQUFMLEdBQWVBLE9BQWY7O0VBQ0Q7O0VBQ0g7QUFBQyxDQWpDRCxDQUE2QkksS0FBN0I7O2VBbUNlQyxjIiwibmFtZXMiOlsiX19leHRlbmRzIiwiY29kZSIsInBhdGgiLCJWRVJTSU9OIiwic3BsaXQiLCJtZXNzYWdlIiwiX3N1cGVyIiwiX3RoaXMiLCJuYW1lIiwiRXJyb3IiLCJBc3NlcnRpb25FcnJvciJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvQXNzZXJ0aW9uRXJyb3IuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=